import { isArray } from 'lodash';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Progress } from '../ui/progress';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'src/components/ui/BrandSelect';
import { delay } from '../../components/utils/GlobalFunctions';
import ACTIONS from '../../store/action';
import { Actions as ADMINACTIONS } from '../../store/actions/adminActions';
import { Actions as METRICACTIONS } from '../../store/actions/metricActions';
import { Actions as ORGANISATIONACTIONS } from '../../store/actions/organisationActions';
import { Actions as REPORTACTIONS } from '../../store/actions/reportActions';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';
import { Button } from '../ui/button';
import { X, Loader2, Ban } from 'lucide-react';
import UploadBtn from '../Common/ReusableComponents/UploadBtn';

const ConfirmationModal = ({
  toggleModal,
  modalProps,
  modalData,
  branding,
  progressState,
  toggleCognitoUserStatus,
  clearReportCacheDate,
  disconnectOrganisation,
  deleteItemFromDB,
  selectedAccounts,
  selectedTrackingCategory,
  selectedTrackingOptions,
  method,
  saveOrganisationSettings,
  saveOrganisation,
  tenant,
  tenants,
  setTenant,
  confirmationModal,
  deleteUsageData,
  sageConnected,
  recalculateUsage,
  bulkAddXeroOptions,
  modalType,
  reportGeneration,
  organisationCreation,
  apiAccess,
  getAllItemsFromDB,
  getTemplates,
  getTypes,
}) => {
  const { primaryColor, cancelBtn, secondaryColor } = branding.colors;
  const { modalTitle, modalSubtitle, btn, table, type, tableName, extraInfo } = modalProps || {};

  const tenantToOption = (item) => ({
    value: item.tenantId,
    label: item.tenantName,
  });

  const recalcAllUsage = modalType === 'recalcAllUsage' ? true : null;
  const deletingReportsCache = modalType === 'reports-table-cache-delete' ? true : null;
  const recalcOrgUsage = modalType === 'orgs-table-recalcOrgUsage' ? true : null;
  const bulkDeleteUsage = modalType === 'usageData-bulk_delete' ? true : null;
  const deleteUsageItem = modalType === 'usageData-delete' ? true : null;
  const reportGenerat = modalType?.includes('OrgReports') ? true : null;
  const deleteOrganisations = modalType?.includes('deleteOrgs') ? true : null;
  const orgCreation = modalType?.includes('OrgCreation') ? true : null;
  const importMixedTemplates = modalType?.includes('importMixedTemplates') ? true : null;
  const excludeOrgFromDeletion = modalType?.includes('excludeOrgFromDeletion');
  const ApiAccess = modalType?.includes('APIAccess') ? true : null;
  const [progressBarActive, setProgressBarActive] = useState(false);
  const [confirmRecalcAllUsage, setConfirmRecalcAllUsage] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [settingsWipeNotice, setSettingsWipeNotice] = useState(table === 'disconnect' && true);
  const [selectedTenant, setSelectedTenant] = useState(
    tenants?.map(tenantToOption).find((tenantOption) => tenantOption.value === tenant),
  );

  useEffect(() => {
    setProgress(0);
  }, [progressBarActive]);

  useEffect(() => {
    if (progressState) setProgress(progressState);
  }, [progressState]);

  if (!confirmationModal) return null;

  return (
    <div className='modal' style={{ display: 'block' }}>
      <div>
        <div className='modal-content'>
          <div className='modal-header'>
            <button
              onClick={() => {
                toggleModal(false, null);
                setProgress(0);
              }}
              className='modal-close'>
              <X size={16} strokeWidth={1.5} />
            </button>
            <h4 className='modal-title' id='modal-title'>
              {modalTitle}
            </h4>
          </div>
          {!progressBarActive && (
            <>
              <div className='modal-body' id='main-body' style={{ display: modalSubtitle ? 'block' : 'none' }}>
                {modalSubtitle}

                {extraInfo && Object.keys(extraInfo).length > 0 && extraInfo.show && (
                  <div style={{ marginTop: 10 }}>
                    {['downloadLink'].includes(extraInfo.action) && (
                      <>
                        {extraInfo.icon && extraInfo.icon}
                        <a className='text-sm text-primary hover:underline cursor-pointer' style={{ marginBottom: '2px' }} href={extraInfo.link}>
                          <span style={{ marginLeft: extraInfo.icon ? 5 : 0 }}>{extraInfo.title}</span>
                        </a>
                      </>
                    )}
                  </div>
                )}

                {modalData?.selectOrg && (
                  <div style={{ marginTop: '10px' }}>
                    <Select
                      isClearable={false}
                      isSearchable={true}
                      options={modalData?.tenants?.map(tenantToOption)}
                      value={selectedTenant}
                      onChange={(selectedOption) => {
                        if (table === 'disconnect') {
                          if (selectedOption.value === tenant) {
                            setSettingsWipeNotice(true);
                          } else {
                            setSettingsWipeNotice(false);
                          }
                        }
                        setSelectedTenant(selectedOption);
                      }}></Select>
                  </div>
                )}
                {settingsWipeNotice && (
                  <p style={{ marginTop: '10px', marginBottom: '0px', color: 'red', fontWeight: 'bold' }}>
                    {`Please note, by disconnecting ${
                      selectedTenant?.label
                    } you will lose integration settings in CYF connected to this ${
                      sageConnected ? 'Sage' : 'Xero'
                    } organisation.`}
                  </p>
                )}
              </div>

              <div
                className='modal-body'
                style={{
                  marginBottom: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: recalcAllUsage ? 'column' : 'row',
                  alignItems: 'center',
                }}>
                {recalcAllUsage && (
                  <div className="flex items-center gap-2">
                    <Checkbox
                      id="confirm-recalc"
                      checked={confirmRecalcAllUsage}
                      onCheckedChange={setConfirmRecalcAllUsage}
                    />
                    <Label htmlFor="confirm-recalc">Please check to confirm this action.</Label>
                  </div>
                )}
                <div style={{ display: 'flex' }}>
                  {btn && !deleteOrganisations && !importMixedTemplates ? (
                    <Button
                      id='confirm-btn'
                      disabled={
                        (modalData?.selectOrg && !selectedTenant) || (recalcAllUsage && !confirmRecalcAllUsage) || loading
                      }
                      onClick={async () => {
                        setLoading(true);
                        if (tableName === 'profile') {
                          // This function is just for profile table - disable user
                          await toggleCognitoUserStatus(tableName, modalData);
                          toggleModal(false, null);
                        } else if (deletingReportsCache) {
                          // This function is to clear the report cache date
                          await clearReportCacheDate(modalData.id);
                          toggleModal(false, null);
                        } else if (recalcOrgUsage) {
                          // Recalculate Org / Subentity Usage
                          await recalculateUsage(modalData.id);
                          toggleModal(false, null);
                        } else if (recalcAllUsage) {
                          // Recalculate Org / Subentity Usage
                          await recalculateUsage('recalcAllUsage');
                          toggleModal(false, 'recalcAllUsage');
                        } else if (type === 'bulkAddXeroOptions') {
                          await bulkAddXeroOptions(modalData?.selectedTrackingCategory);
                          toggleModal(false, null);
                        } else if (excludeOrgFromDeletion) {
                          await saveOrganisation(modalData);
                          toggleModal(false, null);
                        } else if (table === 'disconnect') {
                          await disconnectOrganisation(type, selectedTenant?.value || tenant);
                          toggleModal(false, null);
                        } else if (tableName === 'usageData') {
                          const usageArray = deleteUsageItem ? [modalData] : modalData;
                          const adminPortalAction = bulkDeleteUsage || deleteUsageItem;
                          await deleteUsageData(usageArray, adminPortalAction);
                          setProgress(0);
                          setProgressBarActive(true);
                        } else if (table === 'saveXero') {
                          if (method === 'accountcodes') {
                            await saveOrganisationSettings({ selectedAccounts, method, type: 'xero' });
                          } else {
                            await saveOrganisationSettings({
                              selectedTrackingCategory,
                              selectedTrackingOptions,
                              method,
                              type: 'xero',
                            });
                          }
                          toggleModal(false, null);
                        } else if (table === 'saveXeroTenant') {
                          await setTenant(modalData?.tenant);
                          toggleModal(false, null);
                        } else if (table === 'selectIntegrationOrg') {
                          await setTenant(selectedTenant?.value);
                          toggleModal(false, null);
                        } else if (reportGenerat) {
                          await reportGeneration(modalData);
                          toggleModal(false, null);
                        } else if (orgCreation) {
                          await organisationCreation(modalData);
                        } else if (ApiAccess) {
                          await apiAccess(modalData);
                          toggleModal(false, null);
                        } else if (tableName === 'templates') {
                          await deleteItemFromDB(tableName, [{ ...modalData }]);
                          toggleModal(false, null);
                          getTemplates();
                        } else {
                          // Delete Item From DB
                          if (isArray(modalData))
                            await deleteItemFromDB(
                              tableName,
                              modalData?.map((x) => ({ id: x.id })),
                            );
                          else {
                            await deleteItemFromDB(tableName, [{ ...modalData }]);
                            if (tableName === 'usageTypes') {
                              await delay(10);
                              getTypes();
                            }
                          }
                          toggleModal(false, null);
                          getAllItemsFromDB(tableName, true);
                        }
                        setLoading(false);
                      }}>
                      {loading && <Loader2 size={16} strokeWidth={1.5} className='animate-spin' style={{ marginRight: 5 }} />}
                      {btn?.title}
                    </Button>
                  ) : deleteOrganisations ? (
                    <UploadBtn action={'deleteOrgs'} toggleModal={toggleModal} />
                  ) : importMixedTemplates ? (
                    <UploadBtn action={'importMixedTemplates'} toggleModal={toggleModal} />
                  ) : null}
                  <Button
                    id='delete-cancel-btn'
                    variant='outline'
                    style={{
                      marginLeft: 40,
                      width: 104,
                      display: 'flex',
                      backgroundColor: cancelBtn || secondaryColor,
                      alignItems: 'center',
                    }}
                    onClick={() => toggleModal(false, null)}>
                    <Ban size={16} strokeWidth={1.5} style={{ marginRight: '8px' }} /> Cancel
                  </Button>
                </div>
              </div>
            </>
          )}
          {progressBarActive && (
            <div className='modal-body flex justify-center mb-2.5'>
              <div className="w-full flex flex-col items-center gap-2 min-h-[10vh]">
                <div className="w-[90%] flex items-center gap-4">
                  <Progress value={progress} className="h-2 rounded flex-1" />
                  <span className="min-w-[35px] text-sm text-muted-foreground">{`${Math.round(progress)}%`}</span>
                </div>
                {progress === 100 && (
                  <p className="text-center">Usage Data has been Deleted Successfully!</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const modalType = state?.admin?.modal?.modal;

  return {
    confirmationModal: state.admin?.modal?.confirmationModal,
    modalProps: state.admin?.modal?.modalProps,
    modalData: state.admin?.modal?.item,
    modalType,
    branding: state?.branding,
    progressState: state?.progress,
    selectedAccounts: state?.selectedAccounts,
    selectedTrackingCategory: state?.selectedTrackingCategory,
    selectedTrackingOptions: state?.selectedTrackingOptions,
    method: state?.method,
    tenants: state.tenants,
    tenant: state.tenant,
    sageConnected: state?.sageConnected,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveOrganisationSettings: (settings) => dispatch(ACTIONS.saveOrganisationSettings(settings)),
  toggleModal: (status, action) => dispatch(ADMINACTIONS.toggleModal(status, action)),
  reportGeneration: (orgDetails) => dispatch(ORGANISATIONACTIONS.reportGeneration(orgDetails)),
  organisationCreation: (orgDetails) => dispatch(ORGANISATIONACTIONS.organisationCreation(orgDetails)),
  apiAccess: (orgDetails) => dispatch(ORGANISATIONACTIONS.apiAccess(orgDetails)),
  toggleCognitoUserStatus: (table, item) => dispatch(ADMINACTIONS.toggleCognitoUserStatus(table, item)),
  clearReportCacheDate: (reportId) => dispatch(REPORTACTIONS.clearReportCacheDate(reportId)),
  disconnectOrganisation: (type, tenantId) => dispatch(ACTIONS.disconnectOrganisation(type, tenantId)),
  deleteItemFromDB: (table, item) => dispatch(ADMINACTIONS.deleteItemFromDB(table, item)),
  recalculateUsage: (id) => dispatch(ADMINACTIONS.recalculateUsage(id)),
  deleteUsageData: (items, adminPortal) => dispatch(USAGEACTIONS.deleteUsageData(items, adminPortal)),
  setTenant: (tenant) => dispatch(ACTIONS.saveTenant(tenant)),
  selectTrackingCategory: (selected) => dispatch(ACTIONS.selectTrackingCategory(selected)),
  bulkAddXeroOptions: (trackingCategory) => dispatch(ACTIONS.bulkAddXeroOptions(trackingCategory)),
  saveOrganisation: (orgDetails) => dispatch(ORGANISATIONACTIONS.saveOrganisation(orgDetails)),
  getAllItemsFromDB: (table, force) => dispatch(ADMINACTIONS.getAllItemsFromDB(table, null, force)),
  getTypes: () => dispatch(METRICACTIONS.getTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
